import { ClaimDialogContentContainer } from './ClaimDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

function ClaimDialog({ open, setOpen }: CommonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <ClaimDialogContentContainer closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const claimDialogConfig: DialogConfig<CommonDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: ClaimDialog,
  name: 'ClaimDialog',
}
